import type { ButtonProps } from "antd";

import { Button } from "antd";
import classNames from "classnames";

export const GalleryThumbnailButton = ({
  onClick,
  className,
  ...props
}: ButtonProps) => {
  return (
    <Button
      color="default"
      variant="text"
      shape="circle"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      className={classNames("gallery-thumbnail-button", className)}
      {...props}
    />
  );
};
